import React from 'react';
import { useNavigate } from 'react-router-dom';

const AuthHeader = () => {
  const navigate = useNavigate();

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/80 backdrop-blur-md border-b border-gray-200 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div 
            className="flex items-center gap-2 cursor-pointer group"
            onClick={() => navigate('/')}
          >
            <img 
              src="/AutomateSEO-logo.png" 
              alt="AutomateSEO.ai" 
              className="h-10 w-auto group-hover:scale-105 transition-transform"
            />
            <span className="text-xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              AutomateSEO.ai
            </span>
          </div>

          {/* Navigation Links */}
          <nav className="hidden md:flex items-center gap-6">
            <a href="/#features" className="text-gray-600 hover:text-blue-600 transition-colors">
              Features
            </a>
            <a href="/#pricing" className="text-gray-600 hover:text-blue-600 transition-colors">
              Pricing
            </a>
            <a href="/about" className="text-gray-600 hover:text-blue-600 transition-colors">
              About
            </a>
          </nav>

          {/* Back to Home Button */}
          <button
            onClick={() => navigate('/')}
            className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-blue-600 transition-colors"
          >
            ← Back to Home
          </button>
        </div>
      </div>
    </header>
  );
};

export default AuthHeader;
